import { render } from "./EmployeeSalaryComponent.vue?vue&type=template&id=435aabbb"
import script from "./EmployeeSalaryComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__